import { gql } from 'apollo-boost'

const REMOVE_USER = gql`
  mutation removeUser {
    removeUser @client
  }
`

export default REMOVE_USER
